import {
    React,
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';

import {
    CONFIRM_TYPES,
    DEFAULT_ROW_PER_PAGE,
    DEFAULT_HOMEPAGE_ROW_PER_PAGE,
    ROW_PER_PAGE_OPTIONS,
    SIM_TYPE_LIST,
    SIM_TYPE_LIST_OBJ,
} from 'src/utils/constants';

import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    TextField,
    Typography,
    Grid,
    Select,
    MenuItem,
    Select as Select1,
    InputAdornment,
    SvgIcon,
    InputLabel,
    TableCell,
} from '@material-ui/core';

import { Outlet, Link, useNavigate, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

import moment from 'moment';
import numeral from 'numeral';

import { SimsoAction } from 'src/actions/simso.action';
import { BaivietAction } from 'src/actions/baiviet.action';
import { OrderAction } from 'src/actions/order.action';

import CustomSlider from '../CustomSlider';
import CustomSlider1 from '../CustomSlider1';
import { SettingAction } from 'src/actions/setting.action';

const TheHomepageMainLayout = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const currentPage = queryParams.get("page");
    const { homepageOrderLimitItems, homepageOrderLimitTotal, homepageOrderLimitFilter } = useSelector(state => state.order);
    const { homepageBaivietLimitItems, homepageBaivietLimitTotal, homepageBaivietLimitFilter } = useSelector(state => state.baiviet);
    const { homepageBaivietKhongNoiBatLimitItems, homepageBaivietKhongNoiBatLimitTotal, homepageBaivietKhongNoiBatLimitFilter } = useSelector(state => state.baiviet);
    const [so_dien_thoai, setSoDienThoai] = useState("");
    const [loai_sim, setLoaiSim] = useState({});
    const [menuOpen, setMenuOpen] = useState(false);
    const [min_custom_price, setMinCustomPrice] = useState("0");
    const [max_custom_price, setMaxCustomPrice] = useState("10,000,000");
    const [min_custom_price_raw, setMinCustomPriceRaw] = useState("0");
    const [max_custom_price_raw, setMaxCustomPriceRaw] = useState("10000000");

    const [banners, setBanners] = useState([]);
    const [banners1, setBanners1] = useState([]);
    const [banners2, setBanners2] = useState([]);
    const [bankAccounts, setBankAccounts] = useState({});
    const [copyright, setCopyright] = useState("");
    const [address, setAddress] = useState("");
    const [hotline, setHotline] = useState("");
    const [facebook, setFacebook] = useState("");
    const [zalo, setZalo] = useState("");

    useEffect(() => {
        async function fetchData() {
            const homepageSettings = await dispatch(SettingAction.getHomepageKeys([
                {
                    "key": "banner",
                },
                {
                    "key": "copyright",
                },
                {
                    "key": "address",
                },
                {
                    "key": "hotline",
                },
                {
                    "key": "facebook",
                },
                {
                    "key": "zalo",
                },
                {
                    "key": "bank_account",
                },
            ]))
          
            if (homepageSettings) {
                try {
                    let banner = JSON.parse(homepageSettings.data.banner);
                    console.log(banner);

                    if (banner) {
                        let tmpBanners = [];

                        if (Object.entries(banner).length > 0) {
                            Object.entries(banner).forEach(([key, value]) => {
                                tmpBanners.push({
                                    image: value.banner_url,
                                    url: value.banner_link,
                                })
                            });

                            setBanners(tmpBanners);
                        }
                    }
                } catch (error) {
                    console.error(error);
                }

                //==========

                try {
                    let bank_account = JSON.parse(homepageSettings.data.bank_account);
                    console.log(bank_account);

                    if (bank_account) {
                        setBankAccounts(bank_account);
                    }
                } catch (error) {
                    console.error(error);
                }

                //==========

                try {
                    let _copyright = homepageSettings.data.copyright;
                    setCopyright(_copyright);
                } catch (error) {
                    console.error(error);
                }

                //==========

                try {
                    let _address = homepageSettings.data.address;
                    setAddress(_address);
                } catch (error) {
                    console.error(error);
                }

                //==========

                try {
                    let _hotline = homepageSettings.data.hotline;
                    setHotline(_hotline);
                } catch (error) {
                    console.error(error);
                }

                //==========

                try {
                    let _zalo = homepageSettings.data.zalo;
                    setZalo(_zalo);
                } catch (error) {
                    console.error(error);
                }

                //==========

                try {
                    let _facebook = homepageSettings.data.facebook;
                    setFacebook(_facebook);
                } catch (error) {
                    console.error(error);
                }
            }
        }
        fetchData();
    }, [])

    useEffect(() => {
        async function fetchData1() {
            if (homepageBaivietLimitItems) {
                try {
                    if (homepageBaivietLimitItems) {
                        let tmpBanners1 = [];

                        if (Object.entries(homepageBaivietLimitItems).length > 0) {
                            Object.entries(homepageBaivietLimitItems).forEach(([key, value]) => {
                                tmpBanners1.push({
                                    title: value.title,
                                    createdAt: value.createdAt,
                                    short_description: value.short_description,
                                    image: value.image,
                                    url: `/trang-chu/${value.loai_bai == "bai_viet" ? "posts" : (value.loai_bai == "tin_tuc" ? "news" : "")}/${value.id}`,
                                })
                            });

                            setBanners1(tmpBanners1);
                        }
                    }
                } catch (error) {
                    console.error(error);
                }
            }
        }
        fetchData1();
    }, [homepageBaivietLimitItems])

    useEffect(() => {
        async function fetchData2() {
            if (homepageBaivietKhongNoiBatLimitItems) {
                try {
                    if (homepageBaivietKhongNoiBatLimitItems) {
                        let tmpBanners2 = [];

                        if (Object.entries(homepageBaivietKhongNoiBatLimitItems).length > 0) {
                            Object.entries(homepageBaivietKhongNoiBatLimitItems).forEach(([key, value]) => {
                                tmpBanners2.push({
                                    title: value.title,
                                    createdAt: value.createdAt,
                                    short_description: value.short_description,
                                    image: value.image,
                                    url: `/trang-chu/${value.loai_bai == "bai_viet" ? "posts" : (value.loai_bai == "tin_tuc" ? "news" : "")}/${value.id}`,
                                })
                            });

                            setBanners2(tmpBanners2);
                        }
                    }
                } catch (error) {
                    console.error(error);
                }
            }
        }
        fetchData2();
    }, [homepageBaivietKhongNoiBatLimitItems])

    useEffect(() => {
        const payload = {
            homepageSimsoPage: 0,
            homepageSimsoLimit: DEFAULT_HOMEPAGE_ROW_PER_PAGE,
            so_dien_thoai: "",
            loai_sim: {},
        };
        dispatch(SimsoAction.updateFilter(payload));

        //==========

        const payload1 = {
            homepageOrderLimitPage: 0,
            homepageOrderLimitLimit: DEFAULT_HOMEPAGE_ROW_PER_PAGE,
        };
        dispatch(OrderAction.updateHomepageLimitFilter(payload1));

        //==========

        const payload2 = {
            homepageBaivietLimitPage: 0,
            homepageBaivietLimitLimit: DEFAULT_HOMEPAGE_ROW_PER_PAGE,
        };
        dispatch(BaivietAction.updateHomepageLimitFilter(payload2));

        //==========

        const payload3 = {
            homepageBaivietKhongNoiBatLimitPage: 0,
            homepageBaivietKhongNoiBatLimitLimit: DEFAULT_HOMEPAGE_ROW_PER_PAGE,
        };
        dispatch(BaivietAction.updateHomepageKhongNoiBatLimitFilter(payload3));
    }, []);

    useEffect(() => {
        refreshHomepageContent();
    }, [location.pathname]);

    const refreshHomepageContent = () => {
        // dispatch(OrderAction.homepageLimitList());
        dispatch(BaivietAction.homepageLimitList());
        dispatch(BaivietAction.homepageKhongNoiBatLimitList());
    }
    
    const onLookup = () => {
        // Gán giá trị mặc định
        queryParams.set("page", 1);

        // Cập nhật URL mà không reload trang
        navigate({
        pathname: location.pathname,
        search: `?${queryParams.toString()}`
        }, { replace: true }); // replace để không thêm vào lịch sử trình duyệt
        
        //==========

        // if (so_dien_thoai === "") {
        //     alert('Vui lòng nhập số sim cần tìm!');
        //     return;
        // }

        let outputLoaiSo = [];

        if (Object.keys(loai_sim).length > 0) {
            Object.entries(loai_sim).forEach(([key, value]) => {
                if (value == 1) {
                    outputLoaiSo.push(key);
                }
            });
        }

        const payload = {
            homepageSimsoPage: 'no_update',
            homepageSimsoLimit: 'no_update',
            so_dien_thoai: so_dien_thoai,
            loai_sim: outputLoaiSo,
            min_custom_price: min_custom_price_raw,
            max_custom_price: max_custom_price_raw,
        };

        dispatch(SimsoAction.updateHomepageFilter(payload));

        if (location.pathname === "/trang-chu") {
            dispatch(SimsoAction.homepageList());
        } else {
            navigate("/trang-chu");
        }
    };

    const chonLoaiSim = (e, value) => {
        setLoaiSim({
            ...loai_sim,
            [value]: e.target.value == 1 ? 2 : 1
        })
    }

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // hoặc 'auto'
        });
    };

    const handleKeyDownSearch = event => {
        if (event.key === 'Enter') {
            onLookup(event);
            setMenuOpen(false);
        }
    };

    const simTypeList = SIM_TYPE_LIST;

    const navItems = [
        { label: "TRANG CHỦ", path: "/trang-chu", new_tab: "no", },
        { label: "MOBIFONE", path: "/trang-chu/goi-cuoc/mobifone", new_tab: "no", },
        { label: "VINAPHONE", path: "/trang-chu/goi-cuoc/vinaphone", new_tab: "no", },
        { label: "VIETTEL", path: "/trang-chu/goi-cuoc/viettel", new_tab: "no", },
        // { label: "BÀI VIẾT", path: "/trang-chu/bai-viet", new_tab: "no", },
        // { label: "TIN TỨC", path: "/trang-chu/tin-tuc", new_tab: "no", },
        { label: "BÀI VIẾT", path: "https://khoso.didongtelecom.vn/trang-chu/bai-viet", new_tab: "yes", },
        { label: "TIN TỨC", path: "https://khoso.didongtelecom.vn/trang-chu/tin-tuc", new_tab: "yes", },
    ];

    return (
        <>
            <Helmet>
                <title>Gói cước 5G - Di Dong Telecom</title>
                <link href="https://fonts.googleapis.com/css2?family=Mulish:wght@300;400;600;700&display=swap" rel="stylesheet"></link>
                <link href="https://fonts.googleapis.com/css2?family=Style+Script&display=swap" rel="stylesheet" />
                {/* <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap" rel="stylesheet" /> */}
                {/* <link href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&display=swap" rel="stylesheet" /> */}
                {/* <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;600;700&display=swap" rel="stylesheet" /> */}
                {/* <link href="https://fonts.googleapis.com/css2?family=Bodoni+Moda:wght@400;600;700&display=swap" rel="stylesheet" /> */}
                {/* <link href="https://fonts.googleapis.com/css2?family=AR+One+Sans:wght@400;700&display=swap" rel="stylesheet"></link> */}
                {/* <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap" rel="stylesheet"></link> */}

                <style>{`
                    :root {
                        --main-color: #37A1FF;
                        --background-color: #F2F2F2;
                    }

                    html, body, #root, .main-layout {
                        background: var(--background-color) !important;
                    }

                    video {
                        background: #000;
                    }
                    
                    .d-none {
                        display: none !important;
                    }

                    .disable {
                        pointer-events: none !important;
                        opacity: 0.5 !important;
                        filter: grayscale(50%) !important;
                        user-select: none !important;
                    }

                    .loading {
                        width: 100px;
                        height: 100px;
                        border-radius: 50%;
                        mix-blend-mode: multiply;
                        margin: auto;
                        background: url(/static/images/loading.gif) no-repeat center center / contain;
                    }

                    .page-btn[disabled], .list-pagination button[disabled] {
                        opacity: 0.5;
                    }

                    .page-btn.current-selected {
                        opacity: 1 !important;
                        background: #FF0000 !important;
                    }

                    .main-layout {
                        /* font-family: muli,Arial,Helvetica,sans-serif; */
                        /* font-family: Times New Roman; */
                        font-family: 'Mulish', sans-serif;
                        display: flex;
                        flex-direction: column;
                        min-height: 100vh;
                    }

                    ul {
                        display: block;
                        list-style-type: disc;
                        margin-block-start: 1em;
                        margin-block-end: 1em;
                        padding-inline-start: 40px;
                        unicode-bidi: isolate;
                    }

                    ol {
                        display: block;
                        list-style-type: decimal;
                        margin-block-start: 1em;
                        margin-block-end: 1em;
                        padding-inline-start: 40px;
                        unicode-bidi: isolate;
                    }

                    .main-content {
                        padding: 0 0 20px 0;
                        display: flex;
                        gap: 20px;
                        flex-wrap: wrap;
                    }

                    .mobile-function-container {
                        padding: 80px 10px 10px 10px;
                        position: fixed;
                        width: 100%;
                        height: 100%;
                        overflow-y: auto;
                        /* background: rgb(240, 240, 240); */
                        background: #FFF;
                        z-index: 99999;
                    }

                    .mobile-function-container-opener {
                        display: flex;
                        align-items: center;
                        background: linear-gradient(135deg, var(--main-color), var(--main-color));
                        /* padding: 10px 30px; */
                        /* border-radius: 5px; */
                        box-shadow: 0px 2px 5px rgba(0,0,0,0.2);
                        /* width: 100%; */
                        justify-content: space-between;
                        flex-wrap: wrap;
                        
                        position: fixed;
                        z-index: 100;
                        width: 15px;
                        height: 53px;
                        right: 0;
                        border-radius: 5px 0 0 5px;
                    }

                    .mobile-function-container-opener > button {
                        height: 10px;
                        position: absolute;
                        top: 21px;
                    }

                    .btn-has-icon {
                        font-size: 24px !important;
                        padding: 0 !important;
                    }

                    .contact-icons {
                        position: fixed;
                        bottom: 0;
                        right: 0;
                        opacity: 0.8;
                        z-index: 99999;
                        width: fit-content;
                    }

                    .search-box {
                        margin-bottom: 20px;
                        background: var(--background-color);
                        padding: 10px;
                        border-radius: 5px;
                        box-shadow: 0px 2px 5px rgba(0,0,0,0.2);
                        display: block;
                        align-items: center;
                        z-index: 99999;
                    }

                    .slide-count {
                        font-size: 10px !important;
                    }

                    .contact-icons.left {
                        left: 0;
                    }

                    .contact-icons .icon {
                        width: 50px;
                        height: 50px;
                        display: block;
                        margin: 10px;
                    }

                    .contact-icons .icon > img {
                        width: 100%;
                        height: 100%;
                    }

                    .contact-icons .icon > img[alt='phone'] {
                        padding: 5px;
                        /* border: 2px solid #FFFFFF; */
                        border-radius: 50%;
                        background-color: #0070B3;
                    }

                    .contact-icons .contact-item-1 {
                        margin: 10px !important;
                        background: #0070B3 !important;
                    }

                    .contact-item-1 .title, .contact-item-1 .content {
                        display: block;
                    }

                    .contact-item-1 .title {
                        font-style: italic;
                        font-weight: bold;
                        font-size: 12px !important;
                        margin-bottom: 3px;
                    }

                    .contact-item-1 .content {
                        font-weight: bold;
                        font-size: 16px !important;
                    }

                    .contact-item-1 .content-region {
                        display: block;
                    }

                    .contact-panel .contact-item, .contact-item-1 {
                        padding: 5px;
                        width: 163px;
                        height: 41px;
                        margin: auto;
                        background: var(--main-color);
                        border-radius: 50px;
                        display: flex;
                        align-items: center;

                    }

                    .contact-panel .contact-item img, .contact-item-1 img {
                        height: 100%;
                        width: auto;
                    }

                    .contact-panel .contact-item span, .contact-item-1 span {
                        color: #FFFFFF;
                        margin-left: 5px;
                    }

                    .contact-panel .contact-item.zalo, .contact-item-1.zalo {
                        /* background: #0070B3; */
                    }

                    .contact-panel .contact-item.zalo span, .contact-item-1.zalo span {
                        color: #FFFFFF;
                    }

                    .contact-panel .contact-item.facebook, .contact-item-1.facebook {
                        /* background: #0070B3; */
                    }

                    .contact-panel .contact-item.facebook span, .contact-item-1.facebook span {
                        color: #FFFFFF;
                    }

                    .contact-panel .contact-item.messenger, .contact-item-1.messenger {
                        /* background: #0070B3; */
                    }

                    .contact-panel .contact-item.messenger span, .contact-item-1.messenger span {
                        color: #FFFFFF;
                    }

                    .contact-panel .contact-item.phone, .contact-item-1.phone {
                        /* background: #0070B3; */
                    }

                    .contact-panel .contact-item.phone span, .contact-item-1.phone span {
                        color: #FFFFFF;
                    }

                    .sim-meaning {
                        margin-bottom: 20px;
                    }

                    .sim-meaning .title {
                        text-align: center;
                        font-size: 20px;
                    }

                    .sim-meaning .meaning {
                        margin: 20px;
                        color: #ad0909;
                        font-size: 45px;
                        /* font-family: 'SVNShintiaScript', Arial, sans-serif; */
                        font-family: 'Style Script', cursive;
                    }

                    .sim-meaning .detail-meaning {
                        line-height: 26px;
                        font-size: 16px;
                    }

                    .sim-analysis {
                        line-height: 26px;
                        font-size: 16px;
                    }

                    .sim-analysis h2 {
                        font-size: 20px;
                        margin: 10px 0;
                    }

                    .baiviet-item .title {
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 4;
                        overflow: hidden;
                        text-overflow: ellipsis;

                        font-size: 18px;
                        font-weight: bold;
                        text-align: left;
                    }

                    .baiviet-item .date {
                        font-size: 16px;
                        text-align: left;
                        padding-top: 10px;
                    }

                    .baiviet-item .short-description {
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 4;
                        overflow: hidden;
                        text-overflow: ellipsis;

                        font-size: 16px;
                        text-align: left;
                        padding-top: 10px;
                    }

                    .regular-panel > h3 {
                        font-size: 16px;
                    }

                    .filter-item {
                        display: flex;
                        margin-bottom: 5px;
                    }

                    .filter-item .filter-checkbox {
                        width: 20px;
                        height: 15px;
                        margin-right: 5px;
                    }

                    .filter-item .filter-text {
                        width: 100%;
                    }

                    .sim-item {
                        padding: 8px !important;
                        min-height: 81px;
                    }

                    .sim-item .price {
                        margin-top: 5px;
                    }
                    
                    .sim-item .price * {
                        font-size: 18px;
                    }

                    .simvip .operator-icon {
                        min-width: 50px;
                        width: 50px;
                        height: 50px;
                        border-radius: 50%;
                        -moz-box-shadow: -1px 1px 1px rgba(0,0,0,0.25);
                        -webkit-box-shadow: -1px 1px 1px rgba(0,0,0,0.25);
                        box-shadow: -1px 1px 1px rgba(0,0,0,0.25);
                    }

                    .simvip .sim {
                        font-size: 20px !important;
                        font-weight: bold;
                        text-align: right;
                    }

                    .simvip .sim * {
                        font-size: 20px !important;
                        font-weight: bold;
                    }

                    .simvip .sim .number-highlight {
                        color: #FF0000 !important;
                    }

                    .simvip .price {
                        font-size: 16px !important;
                        font-weight: bold;
                        text-align: right;
                        color: var(--main-color);
                    }

                    .post-show {
                        display: block;
                        justify-content: space-between;
                        align-items: center;
                        padding: 0;
                        background: transparent;
                        border-radius: 10px;
                    }

                    .post-show .post-title {
                        border-bottom: 3px solid gray;
                        padding-bottom: 10px;
                        margin-bottom: 20px;
                        color: var(--main-color);
                    }

                    .post-show .post-short-description {
                        margin-bottom: 20px;
                    }

                    .media-content img, 
                    .media-content video,
                    .media-item {
                        max-width: 100% !important;
                        max-height: calc(100vh - 100px) !important;
                        display: block !important;
                        margin-left: auto !important;
                        margin-right: auto !important;
                    }

                    .post-show .post-img {
                        margin-bottom: 20px !important;
                    }

                    .simdata5g-item .name {
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        text-overflow: ellipsis;

                        font-size: 20px;
                        font-weight: bold;
                        text-align: left;
                        margin-top: 10px;
                    }

                    .simdata5g-item .price {
                        font-size: 24px;
                        font-weight: bold;
                        text-align: left;
                        margin-top: 10px;
                        color: var(--main-color);
                        float: right;
                    }

                    .simdata5g-item .price * {
                        float: right;
                    }

                    .simso-one-detail * {
                        font-size: 18px;
                    }

                    .simso-one-detail .price {
                        font-size: 24px;
                    }

                    .simdata5g-one-detail * {
                        font-size: 18px;
                    }

                    .simdata5g-one-detail .price {
                        font-size: 24px;
                    }

                    .form-dat-hang {
                        grid-template-columns: repeat(2, 1fr);
                    }

                    .simso-one-ynghiasim .detail-meaning, .simso-one-ynghiasim .sim-analysis {
                        display: none;
                    }

                    .noti-simple {
                        display: inline;
                        font-size: 80% !important;
                        color: white;
                        background: red;
                        border-radius: 3px;
                        padding: 3px;
                    }

                    .goicuoc5g-item .name {
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        text-overflow: ellipsis;

                        font-size: 20px;
                        font-weight: bold;
                        text-align: left;
                        margin-top: 10px;
                    }

                    .goicuoc5g-item .price {
                        font-size: 24px;
                        font-weight: bold;
                        text-align: left;
                        margin-top: 10px;
                        color: var(--main-color);
                        float: right;
                    }

                    .goicuoc5g-item .price * {
                        float: right;
                    }

                    .goicuoc5g-one-detail * {
                        font-size: 18px;
                    }

                    .goicuoc5g-one-detail .price {
                        font-size: 24px;
                    }

                    .goicuoc5g-item.list_Sim {
                        /* max-width: 100%; */
                        width: 258.87px;
                        height: 296px;
                        background: #ffffff;
                        /* margin: 20px; */
                        margin: auto;
                        border-radius: 20px;
                        position: relative;
                        box-shadow: 0 4px 8px 0 rgb(0 0 0 / 20%), 0 6px 20px 0 rgb(0 0 0 / 19%);
                    }

                    .goicuoc5g-item.list_Sim p.list_Sim_1 {
                        width: 100%;
                        font-style: normal;
                        font-weight: bold;
                        font-size: 25px !important;
                        line-height: 55px;
                        letter-spacing: 0.02em;
                        color: #ffffff;
                        padding-top: 12px;
                        position: absolute;
                        z-index: 5;
                        text-align: -webkit-center;
                    }

                    .goicuoc5g-item.list_Sim .img_cong {
                        width: 100%;
                        /* height: 82px; */
                        /* object-fit: cover; */
                        /* object-position: bottom; */
                        border-radius: 20px 20px 0 0;
                        /* position: absolute; */
                        top: 0px;
                        left: 0px;
                        z-index: 1;
                    }

                    .goicuoc5g-item.list_Sim .sim_hot {
                        width: 55px;
                        position: absolute;
                        top: -10px;
                        right: -12px;
                        z-index: 1;
                    }

                    .goicuoc5g-item.list_Sim .list_Sim_23 {
                        height: 138px;
                        margin: 10px 0;
                        overflow: auto;
                        text-align: -webkit-center;
                    }

                    .goicuoc5g-item.list_Sim .list_Sim_23 p {
                        font-style: normal;
                        font-weight: 500;
                        font-size: 18px !important;
                        line-height: 26px;
                        letter-spacing: 0.02em;
                        color: #666666;
                        padding: 0px 16px;
                    }

                    .goicuoc5g-item.list_Sim .boder_dotted {
                        border-bottom: 1px solid;
                        border-style: none none dotted none;
                    }

                    .goicuoc5g-item.list_Sim .left {
                        float: left;
                        width: 48%;
                        padding: 0px;
                        margin-right: 5px;
                    }

                    .goicuoc5g-item.list_Sim .right {
                        float: right;
                        width: 48%;
                        padding: 0px;
                    }

                    .goicuoc5g-item.list_Sim .btn1 {
                        grid-area: btn1;
                        border: 1px solid #0065FF;
                        border-radius: 10px;
                        padding: 9px 0px;
                        position: relative;
                        text-align: center;
                        grid-column: 1 / 8;
                        font-style: normal;
                        font-weight: bold;
                        font-size: 14px !important;
                        line-height: 18px;
                        background: #0065FF;
                        z-index: 10;
                        color: #fff;
                        width: 86%;
                        height: 40px;
                        display: inline-block;
                        margin: 0 0 0 10px;
                        cursor: pointer;
                    }

                    .goicuoc5g-item.list_Sim .btn2 {
                        grid-area: btn1;
                        border: 1px solid #0065FF;
                        border-radius: 10px;
                        padding: 9px 0px;
                        position: relative;
                        text-align: center;
                        grid-column: 1 / 8;
                        font-style: normal;
                        font-weight: bold;
                        font-size: 14px !important;
                        line-height: 18px;
                        background: #ffffff;
                        z-index: 10;
                        color: #0065FF;
                        width: 82%;
                        height: 40px;
                        display: inline-block;
                        margin: 0 0 0 10px;
                        cursor: pointer;
                    }

                    .btn-home, .btn-search {
                        font-size: 28px !important;
                    }
                      
                    .pause-stamp {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%) rotate(-25deg);
                        white-space: nowrap;
                        color: #b30000;
                        border: 3px solid #b30000;
                        padding: 6px 18px;
                        font-weight: 900;
                        font-size: 26px;
                        text-transform: uppercase;
                        opacity: 0.9;
                        border-radius: 4px;
                        font-family: 'Courier New', Courier, monospace;
                        pointer-events: none;
                        z-index: 10;
                        letter-spacing: 2px;
                        background: transparent;
                        box-shadow:
                            0 0 0 1px rgba(179, 0, 0, 0.6),
                            inset 0 0 0 2px rgba(179, 0, 0, 0.3),
                            2px 2px 6px rgba(0, 0, 0, 0.2);
                        filter: contrast(1.2) brightness(1.05);
                        mix-blend-mode: multiply;
                    }

                    .btn-home, .btn-search {
                        font-size: 28px !important;
                    }

                    .goicuoc-search-region, .goicuoc-search-region * {
                        font-family: Mulish, sans-serif;
                    }

                    @media (min-width: 1000px) {
                        .main-layout {
                            width: 1000px;
                            margin: auto;
                        }
                    }

                    @media (min-width: 768px) {
                        .mobile {
                            display: none;
                        }
    
                        .desktop {
                            display: block;
                        }

                        .btn-search {
                            border-radius: 0 5px 5px 0;
                        }

                        .filter-container * {
                            font-size: 16px !important;
                        }
                    }

                    @media (max-width: 768px) {
                        .main-content {
                            padding: 0 10px 10px 10px;
                        }

                        .home-logo {
                            text-align: center;
                            width: 100%;
                        }

                        .header-container {
                            flex-direction: column;
                            align-items: center;
                        }

                        .main-content {
                            flex-direction: column;
                        }

                        .mobile {
                            display: block;
                        }
    
                        .desktop {
                            display: none !important;
                        }

                        .sim-list-show{
                            grid-template-columns: repeat(2, 1fr) !important;
                        }

                        .baiviet-list-show{
                            grid-template-columns: repeat(1, 1fr) !important;
                        }

                        .simdata5g-list-show{
                            grid-template-columns: repeat(2, 1fr) !important;
                        }

                        .page-content {
                            max-width: 100%;
                            padding-top: 20px;
                        }

                        .btn-search {
                            border-radius: 0;
                            /* border-right: 1px solid var(--main-color) !important; */
                        }

                        .search-textbox {
                            border-radius: 0 !important;
                        }

                        .search-box {
                            position: fixed;
                            top: 0;
                            left: 0;
                            width: 100%;
                        }

                        .contact-icons .icon {
                            width: 40px;
                            height: 40px;
                        }

                        .main-banner {
                            margin-top: 60px;
                        }

                        .simvip .operator-icon {
                            min-width: 35px;
                            width: 35px;
                            height: 35px;
                        }

                        .simvip .sim {
                            font-size: 20px !important;
                        }

                        .simvip .sim * {
                            font-size: 20px !important;
                        }

                        .simvip .price {
                            font-size: 16px !important;
                        }

                        .sim-meaning .title, .sim-meaning .title > b {
                            font-size: 16px !important;
                        }
    
                        .sim-meaning .meaning * {
                            font-size: 30px !important;
                            margin: 10px;
                        }
    
                        .sim-meaning .detail-meaning * {
                            line-height: 18px !important;
                        }
    
                        .sim-analysis div * {
                            line-height: 18px !important;
                        }
    
                        .sim-analysis h2 {
                            font-size: 16px !important;
                        }

                        .simdata5g-one-detail-container {
                            display: block !important;
                        }

                        .simdata5g-one-detail-container .simdata5g-one-img {
                            width: 100% !important;
                            padding: 0 0 20px 0 !important;
                        }

                        .simdata5g-one-detail-container .simdata5g-one-detail {
                            width: 100% !important;
                            padding: 0 !important;
                        }

                        .simdata5g-one-detail-container .simdata5g-one-detail .price {
                            font-size: 22px !important;
                        }

                        .simso-one-detail-container {
                            display: block !important;
                        }

                        .simso-one-detail-container .simso-one-img {
                            width: 100% !important;
                            padding: 0 0 20px 0 !important;
                        }

                        .simso-one-detail-container .simso-one-detail {
                            width: 100% !important;
                            padding: 0 !important;
                        }

                        .simso-one-detail-container .simso-one-detail .so-sim {
                            font-size: 24px !important;
                        }

                        .simso-one-detail-container .simso-one-detail .price {
                            font-size: 22px !important;
                        }

                        .form-dat-hang {
                            grid-template-columns: repeat(1, 1fr);
                        }

                        .goicuoc5g-list-show{
                            grid-template-columns: repeat(2, 1fr) !important;
                        }

                        .goicuoc5g-one-detail-container {
                            display: block !important;
                        }

                        .goicuoc5g-one-detail-container .goicuoc5g-one-img {
                            width: 100% !important;
                            padding: 0 0 20px 0 !important;
                        }

                        .goicuoc5g-one-detail-container .goicuoc5g-one-detail {
                            width: 100% !important;
                            padding: 0 !important;
                        }

                        .goicuoc5g-one-detail-container .goicuoc5g-one-detail .price {
                            font-size: 22px !important;
                        }

                        .goicuoc5g-item.list_Sim p.list_Sim_1 {
                            font-size: 18px !important;
                            line-height: 25px !important;
                        }
    
                        .goicuoc5g-item.list_Sim .list_Sim_23 p {
                            font-size: 16px !important;
                        }
    
                        .goicuoc5g-item.list_Sim .btn1 {
                            font-size: 12px !important;
                        }
    
                        .goicuoc5g-item.list_Sim .btn2 {
                            font-size: 12px !important;
                        }

                        .goicuoc5g-item.list_Sim {
                            width: auto;
                            height: 265px;
                        }

                        .goicuoc5g-item.list_Sim .sim_hot {
                            width: 40px !important;
                        }

                        .goicuoc5g-item.list_Sim .btn1, .goicuoc5g-item.list_Sim .btn2 {
                            margin-left: 5px;
                        }
                    }

                    @media (max-width: 1199px) {
                        * {
                            font-size: 16px !important;
                        }
                    }
                `}</style>
            </Helmet>
            {/* <div className="main-layout" onClick={() => { refreshHomepageContent(); }}> */}
            <div className="main-layout">
                <CustomSlider className="main-banner" banners={banners} showSlideCount={1} showPrevBtn={1} showNextBtn={1} />

                {/* Contact Icons */}
                <div className='contact-icons left'>
                    <a className='contact-item-1 phone' href={`tel:${hotline ? hotline.replace(/\./g, '') : ''}`}>
                        <img src="/static/images/phone_white.svg" alt="phone" />
                        <div className='content-region'>
                            <span className='title'>Gọi tư vấn</span>
                            <span className='content'>{hotline}</span>
                        </div>
                    </a>
                </div>
                <div className='contact-icons'>
                    <a className='icon' href={`https://zalo.me/${zalo ? zalo.replace(/\./g, '') : ''}`} target='_blank' rel="noopener noreferrer">
                        <img src="/static/images/zalo.svg" alt="zalo" />
                    </a>
                    <a className='icon' href={`https://facebook.com/${facebook}`} target='_blank' rel="noopener noreferrer">
                        <img src="/static/images/facebook.svg" alt="facebook" />
                    </a>
                    <a className='icon' href={`https://m.me/${facebook}`} target='_blank' rel="noopener noreferrer">
                        <img src="/static/images/messenger.svg" alt="messenger" />
                    </a>
                </div>
                
                {/* Hamburger Menu Button */}
                <div onClick={() => { setMenuOpen(!menuOpen); }} className='mobile d-none' style={{padding: "20px 20px 0 20px"}}>
                    <div className="header-container mobile-function-container-opener" style={{
                        
                    }}>
                        <button onClick={() => { setMenuOpen(!menuOpen); }} style={{ background: "none", border: "none", fontSize: "30px", cursor: "pointer", color: "#FFFFFF" }}>
                            {/* ☰ */}
                            {menuOpen ? ">" : "<"}
                        </button>
                    </div>
                </div>

                {menuOpen && (
                    <div className='mobile mobile-function-container'>
                        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginBottom: 15 }}>
                            {navItems.map((item, index) => (<>
                                <button
                                    key={index}
                                    onClick={() => {
                                        setMenuOpen(false);
                                        if (item.new_tab == 'yes') {
                                            window.open(item.path, "_blank");
                                        } else {
                                            navigate(item.path);
                                        }
                                    }}
                                    style={{
                                        // width: "40px",
                                        // height: "40px", 
                                        flex: '1 1 0%',
                                        padding: "10px", 
                                        fontSize: "16px", 
                                        background: "var(--main-color)", 
                                        color: "#fff", 
                                        border: "1px solid var(--main-color)", 
                                        borderRadius: "5px", 
                                        cursor: "pointer",
                                        transition: "background 0.3s",
                                        minWidth: 180,
                                    }}
                                    onMouseEnter={e => e.target.style.background = "var(--main-color)"}
                                    onMouseLeave={e => e.target.style.background = "var(--main-color)"}
                                >
                                    {item.label}
                                </button>
                            </>))}
                        </div>
                    </div>
                )}
                
                {/* Header */}
                <header className='desktop' style={{ 
                    // padding: "15px", 
                    padding: "0 0 15px 0",
                    display: "flex", 
                    justifyContent: "center", 
                    alignItems: "center", 
                    flexWrap: "wrap" 
                }}>
                    {/* Logo, Menu & Hotline in a single container */}
                    <div className="header-container" style={{
                        display: "flex", 
                        alignItems: "center", 
                        gap: "30px", 
                        background: "linear-gradient(135deg, var(--main-color), var(--main-color))", 
                        // padding: "10px 30px", 
                        // padding: "20px 30px", 
                        // borderRadius: "5px",
                        boxShadow: "0px 2px 5px rgba(0,0,0,0.2)", 
                        width: "100%", 
                        justifyContent: "space-between",
                        flexWrap: "wrap"
                    }}>
                        {/* Logo */}
                        {/* <Link to="/trang-chu" className="home-logo" style={{ fontWeight: "bold", color: "#fff", margin: 0, flexShrink: 0, textTransform: 'uppercase' }}>khosim.didongtelecom.vn</Link> */}
                        
                        {/* Menu */}
                        <nav style={{ 
                            background: "transparent", 
                            borderRadius: "5px", 
                            flexGrow: 1, 
                            textAlign: "left",
                        }}>
                            <ul style={{ 
                                listStyle: "none", 
                                display: "flex", 
                                margin: 0, 
                                padding: 0, 
                                alignItems: "center", 
                                justifyContent: "space-evenly", 
                                width: "100%",
                            }}>
                                {navItems.map((item, index) => (
                                    <li
                                        key={index}
                                        style={{
                                            flex: 1,
                                            textAlign: "center",
                                            borderLeft: index !== 0 ? "1px solid #ccc" : "none", // 👈 Gạch phân cách
                                        }}
                                    >
                                        <Link
                                            to={item.path}
                                            target={item.new_tab == 'yes' ? '_blank' : ''}
                                            rel={item.new_tab == 'yes' ? 'noopener noreferrer' : ''}
                                            style={{
                                                color: "#fff",
                                                textDecoration: "none",
                                                fontWeight: "bold",
                                                fontSize: "16px",
                                                display: "block",
                                                textTransform: "uppercase",
                                                padding: "10px 0",
                                                transition: "0.3s"
                                            }}
                                            onMouseEnter={(e) => (e.target.style.color = "#ff0")}
                                            onMouseLeave={(e) => (e.target.style.color = "#fff")}
                                        >
                                            {item.label}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </nav>

                        
                        {/* Hotline */}
                        {/* <a href={`tel:${hotline.replace(/\./g, '')}`} style={{ fontWeight:"bold", color: "#fff", display: "flex", alignItems: "center", gap: "5px", flexShrink: 0 }}>
                            <span style={{ fontSize: "22px", color: "#fff" }}>&#128382;</span> {hotline}
                        </a> */}
                    </div>
                </header>
                
                {/* Main Content */}
                <main className="main-content">
                    {/* Main Section (6/10) */}
                    <section className='page-content' style={{ flex: "6" }}>
                        <div className='search-box mobile'>
                            <div style={{display: 'flex'}}> 
                                <button 
                                    className='btn-home mobile btn-has-icon'
                                    onClick={() => { navigate('/trang-chu'); setMenuOpen(false); }}
                                    style={{
                                        width: "40px",
                                        height: "40px", 
                                        padding: "10px", 
                                        fontSize: "16px", 
                                        background: "var(--main-color)", 
                                        color: "#fff", 
                                        border: "1px solid var(--main-color)", 
                                        // borderRadius: "5px 0 0 5px",
                                        borderRadius: "5px", 
                                        cursor: "pointer",
                                        transition: "background 0.3s"
                                    }}
                                    onMouseEnter={e => e.target.style.background = "var(--main-color)"}
                                    onMouseLeave={e => e.target.style.background = "var(--main-color)"}
                                >
                                    ⌂
                                </button>
                                <input 
                                    className='search-textbox'
                                    type="text" 
                                    placeholder="Nhập số sim cần tìm..." 
                                    name="so_dien_thoai"
                                    onChange={(e) => { setSoDienThoai(e.target.value); }}
                                    onKeyDown={handleKeyDownSearch}
                                    value={so_dien_thoai}
                                    style={{
                                        opacity: "0",
                                        flex: "1", 
                                        padding: "10px", 
                                        fontSize: "16px", 
                                        borderRadius: "5px 0 0 5px",
                                        border: "1px solid var(--main-color)", 
                                        textAlign: "left",
                                        height: "40px",
                                    }} />
                                <button 
                                    className='btn-search btn-has-icon'
                                    onClick={(e) => { onLookup(e); setMenuOpen(false); }}
                                    style={{
                                        opacity: "0",
                                        // width: "100px", 
                                        width: "40px",
                                        height: "40px", 
                                        padding: "10px", 
                                        fontSize: "16px", 
                                        background: "var(--main-color)", 
                                        color: "#fff", 
                                        border: "1px solid var(--main-color)", 
                                        // borderRadius: "0 5px 5px 0", 
                                        cursor: "pointer",
                                        transition: "background 0.3s"
                                    }}
                                    onMouseEnter={e => e.target.style.background = "var(--main-color)"}
                                    onMouseLeave={e => e.target.style.background = "var(--main-color)"}
                                >
                                    ⌕
                                </button>
                                <button 
                                    className='mobile btn-has-icon'
                                    onClick={() => { setMenuOpen(!menuOpen); }}
                                    style={{
                                        // width: "100px", 
                                        width: "40px", 
                                        height: "40px", 
                                        padding: "10px", 
                                        fontSize: "16px", 
                                        background: "var(--main-color)", 
                                        color: "#fff", 
                                        border: "1px solid var(--main-color)", 
                                        // borderRadius: "0 5px 5px 0",
                                        borderRadius: "5px",  
                                        cursor: "pointer",
                                        transition: "background 0.3s"
                                    }}
                                    onMouseEnter={e => e.target.style.background = "var(--main-color)"}
                                    onMouseLeave={e => e.target.style.background = "var(--main-color)"}
                                >
                                    ☰
                                </button>
                            </div>
                        </div>

                        <div>
                            <Outlet />
                        </div>
                    </section>
                </main>
                
                {/* Footer */}
                <footer style={{ background: "linear-gradient(135deg, var(--main-color), var(--main-color))", color: "#fff", padding: "20px", textAlign: "center", marginTop: "20px" }}>
                    <p style={{ textTransform: 'uppercase', fontWeight: 'bold' }}>{copyright}</p>
                    <p>Địa chỉ: {address} - Điện thoại: {hotline}</p>
                </footer>
            </div>
        </>
    );
};

export default TheHomepageMainLayout;
